import { Material } from "@/lib/sticker";
import { SectionTitle } from "./SectionTitle";
import { MaterialThumbnail } from "./MaterialThumbnail";
import { useTranslation } from "@/lib/i18n";

interface MaterialSectionProps {
  selectedMaterial: Material;
  onMaterialChange: (material: Material) => void;
}

export const MaterialSection = ({
  selectedMaterial,
  onMaterialChange,
}: MaterialSectionProps) => {
  const t = useTranslation();

  const materials: {
    id: Material;
    label: string;
    preview: string;
    description: string;
  }[] = [
    {
      id: "glossy",
      label: t.materials.glossy,
      preview: "bg-gradient-to-br from-gray-100 via-white to-gray-200",
      description: t.materials.glossyDesc,
    },
    {
      id: "matte",
      label: t.materials.matte,
      preview: "bg-gradient-to-br from-gray-400 to-gray-500",
      description: t.materials.matteDesc,
    },
    {
      id: "translucent",
      label: t.materials.translucent,
      preview: "bg-gradient-to-br from-blue-100/70 to-purple-100/70",
      description: t.materials.translucentDesc,
    },
  ];

  return (
    <div className="p-4">
      <SectionTitle title={t.sections.material} />
      <div className="flex gap-1.5">
        {materials.map((material) => (
          <MaterialThumbnail
            key={material.id}
            material={material}
            selected={material.id === selectedMaterial}
            onClick={() => onMaterialChange(material.id)}
          />
        ))}
      </div>
    </div>
  );
};
